0/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
var Datetime = require('react-datetime');
import * as armazenaProtocoloActions from './actions/armazenaProtocoloActions'
import ProtocoloCadastradoMsgSAC from './ProtocoloCadastradoMsgSAC'

import ProtocoloTimeLineCliente from './ProtocoloTimeLineCliente'
import Helpers from './util/Helpers'
import ConfigD from './util/ConfigD';
import './css/ProtocoloCadastrado.css'
import 'jquery-validation';
import Erro from './Erro';
import $ from 'jquery';

class ProtocoloCadastrado extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
        };
        this.abrirPanel = this.abrirPanel.bind(this);

    }

    abrirPanel(historico, texto) {

        //console.log('historico ', historico);
        //console.log('texto ', texto);

        this.setState({visualizarHistorico:historico, texto:texto});
        if ($('.detailFoot').hasClass('slide-up')) {
            $('.detailFoot').addClass('slide-down', 1000, 'easeOutBounce');
            $('.detailFoot').removeClass('slide-up');
        } else {
            $('.detailFoot').removeClass('slide-down');
            $('.detailFoot').addClass('slide-up', 1000, 'easeOutBounce');
        }

        // if (this.validaForm()) {
        //    //console.log('validou')
        //     self = this
        //     var nome = $('#txtNome').val();
        //     var email = $('#txtEmail').val();

        //     var data = {
        //         nome: nome,
        //         email: email
        //     }
        //    //console.log('data - ', data);
        //     // this.props.actions.ObterMensagemPorProtocoloSenha(data).catch(error => {
        //     //     Alert.warning(!$.isEmptyObject(error.returnStatus)?error.returnStatus.description:'erro inesperado '+ error.statusText, {
        //     //         position: 'top-right',
        //     //         effect: 'slide',
        //     //         offset: 172,
        //     //         timeout: 5000
        //     //     });
        //     // });;

        // }


    }
    componentDidMount() {
        
        this.props.armazenaProtocoloActions.ArmazenaProtocolo('');

    }
    
    componentWillReceiveProps(nextProps) {
        
        if ($.isEmptyObject(nextProps.mensagem)) {
            //console.log('mensagem consultada', nextProps.mensagem)
            this.context.router.push(ConfigD.getServerBase() + '/consultarProtocolo');
        }

    }

    render() {
        if ($.isEmptyObject(this.props.mensagem)){
            return <Erro mensagemErro='Página não encontrada!' />
        }

    return (
        
        <div>
            <div className="breadcrumb-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <h2 className="title">Protocolo cadastrado</h2>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <div className="breadcrumbs pull-right">
                                <ul>
                                    <li>Você está aqui:</li>
                                    <li><a href={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()}>Home</a></li>
                                    <li>Protocolo cadastrado</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 protocoloCadastrado">
                        <h3 className="title">Manifestação cadastrada com sucesso</h3>
                        <p>
                            Obrigado por entrar em contato conosco! Informamos que a sua manifestação foi cadastrada com sucesso.
                        </p>
                        <p>
                            A qualquer momento você pode acompanhar o tratamento da sua manifestação, acessando o endereço eletrônico consultar manifestação e inserindo o número e a senha abaixo:
                        </p>
                        <p>
                            Para sua segurança, solicitamos informar:
                        </p>
                        <div className='centerRow'><strong> Número do protocolo:</strong> {this.props.mensagem.dado.mAtendimento.mProtocolo}</div>
                        <div className='centerRow'><strong>Senha:</strong> {this.props.mensagem.dado.mAtendimento.mSenha}</div>
                        <br/>                        
                        <ProtocoloCadastradoMsgSAC />
                    <div className="divider"></div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

ProtocoloCadastrado.protoType = {
    //actionCliente: PropTypes.object.isRequired
}
ProtocoloCadastrado.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        mensagem: state.mensagem
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       armazenaProtocoloActions: bindActionCreators(armazenaProtocoloActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtocoloCadastrado);



/** WEBPACK FOOTER **
 ** ./src/components/ProtocoloCadastrado.js
 **/